<template>
    <el-scrollbar class="page">
        <slot>
            <router-view :key="$route.fullPath"/>
        </slot>
    </el-scrollbar>
</template>

<script>
export default {}
</script>
